import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Tree } from "@phosphor-icons/react";
import { renderBranch, OrgNodeDrawer } from "@/components/OrgTreeNode";

export default function OrgChart() {
  const [chart, setChart] = useState({ roots: [], total: 0 });
  const [selected, setSelected] = useState(null);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/team/org-chart").then((r) => setChart(r.data || { roots: [], total: 0 }));
  }, []);

  const ceoRoot = (chart.roots || []).find((r) => r.initials === "PM") || (chart.roots || [])[0];

  return (
    <div className="space-y-6" data-testid="org-chart-page">
      <div>
        <div className="flex items-center gap-2 mb-1">
          <Tree size={22} weight="duotone" />
          <h1 className="font-display text-3xl font-bold">Org Chart</h1>
        </div>
        <p className="text-[13px] text-[var(--span-text-2)]">
          Interactive reporting hierarchy · {chart.total} people · data-driven from <span className="font-mono">/api/team/org-chart</span>.
        </p>
      </div>

      <div className="flex flex-wrap gap-1.5">
        {["All", "Executive", "Consulting", "Investigations", "Legal", "Finance"].map((t) => (
          <button
            key={t}
            data-testid={"org-tab-" + t.toLowerCase()}
            onClick={() => setFilter(t)}
            className={"px-3 py-1.5 text-[11px] font-mono tracking-wider uppercase border " + (filter === t ? "bg-white text-black border-white" : "border-[var(--span-border)] text-[var(--span-text-2)] hover:text-white")}
          >
            {t}
          </button>
        ))}
      </div>

      <div className="border border-[var(--span-border)] p-4 sm:p-6 lg:p-8 overflow-x-auto" data-testid="org-chart-tree">
        {ceoRoot ? (
          <div className="flex flex-col items-center min-w-[820px]">
            {renderBranch(ceoRoot, setSelected, filter, 0)}
          </div>
        ) : (
          <div className="text-center text-[13px] text-[var(--span-text-2)] py-12">Loading org chart…</div>
        )}
      </div>

      {selected ? <OrgNodeDrawer node={selected} onClose={() => setSelected(null)} /> : null}
    </div>
  );
}
